import { setOrderCache } from '@/resource/js/common.js'
import global_ from '@/resource/js/GLOBAL2'
const invokeApi = global_.invokeApi;
const salesType = { 'products': 4, 'groups': 2, 'promotions': 1 }
const SHOPTYPE = ['products', 'groups', 'promotions'];
const SHOPID = { products: 'proId', groups: 'groupId', promotions: 'promotionId' }
const LISTTYPE = ['coldChainCart', 'nomalTempCart'];
// initial state
// 相当于vue中的data
const state = {
    //购物车整体数据
    cart_data1: {},
    // 凑单商品数据
    cou_list_data: {
        coldChainCart: null, //自营冷链
        nomalTempCart: null //非自愿常温
    },
    checkAll: true,
    InvalidShop: {
        //单品
        products: [],
        //套装
        groups: [],
        //促销
        promotions: [],
        isNull: true
    },
    recommendList:null
}
// getters
// 相当于vue中的计算属性
const getters = {
    cartGlobal: function() {
        return {
            'price': state.cart_data1.price||0,
            'count': state.cart_data1.count||0,
            'factPrice': state.cart_data1.factPrice||0,
            'notice': state.cart_data1.notice||'',
            'coldchainCount': state.cart_data1.coldchainCount||0,
            'nomalCount': state.cart_data1.nomalCount||0,
            'totalQuantity':state.cart_data1.totalQuantity||0,
            'freight':state.cart_data1.freight||0
        }
    },
    priceInfo: function() {
        if (state.cart_data1) {
            let obj = {}
            if (state.cart_data1.coldchainCount > 0) {
                obj.coldChainCart = {
                    diff: state.cart_data1.coldChainCart.rule.beginAmount > state.cart_data1.coldChainCart.price ? state.cart_data1.coldChainCart.rule.beginAmount - state.cart_data1.coldChainCart.price : 0,
                    beginAmount: state.cart_data1.coldChainCart.rule.beginAmount,
                    baseErrMsg:state.cart_data1.coldChainCart.rule.baseErrMsg,
                    baseSuccess:state.cart_data1.coldChainCart.rule.baseSuccess
                }
            }
            if (state.cart_data1.nomalCount > 0) {
                obj.nomalTempCart = {
                    diff: state.cart_data1.nomalTempCart.rule.beginAmount > state.cart_data1.nomalTempCart.price ? state.cart_data1.nomalTempCart.rule.beginAmount - state.cart_data1.nomalTempCart.price : 0,
                    beginAmount: state.cart_data1.nomalTempCart.rule.beginAmount,
                    baseErrMsg:state.cart_data1.nomalTempCart.rule.baseErrMsg,
                    baseSuccess:state.cart_data1.nomalTempCart.rule.baseSuccess
                }
            }
            return obj
        }
        return null
    },
    checkAll: function() {
        return state.checkAll
    }
}

// actions  异步的 mutations
const actions = {
    initCart({
        commit,
        state
    }, products) {
        // console.log((state.cart_data1.coldChainCart==undefined)&&'coldChainCart')
        invokeApi('shoppingcart/cartList', {}, 'post', Math.random(), function(res) {
            commit('INIT_CART', res)
            // console.log(state.cart_data1.coldChainCart.rule)
            // console.log('==================================cart_data1')
            commit('FORMAT_GIFT')

        })
    },
    // 添加到购物车
    addShopCart({
        commit,
        state
    }, prams) {
        // * salesType：商品类型（1促销、2套装、4单品、5活动）
        // * salesId：商品ID
        // * activeNo：活动号
        // * quantity：增加或减少的数量
        return new Promise((resolve, reject) => {
            let data = {
                salesType: salesType[prams.type],
                salesId: prams.id,
                activeNo: '',
                quantity: prams.num
            }
            console.log(data)
            invokeApi('shoppingcart/addCart', data, 'post', Math.random(), function(res) {
                commit('INIT_CART', res)
                commit('FORMAT_GIFT')
                resolve(res)
            })
        })

    },
    // 删除商品
    removeShopCart({ commit, state }, parms) {
        // salesId：商品ID
        invokeApi('shoppingcart/removeCartProduct', parms, 'post', Math.random(), function(res) {
            commit('INIT_CART', res)
            commit('FORMAT_GIFT')
        })
    },
    // 选中商品
    checkCart({ commit, state }, parms) {
        // * checkType：打钩类型（1全选、-1全部取消、2全选冷链、-2取消冷链、3全选常温、-3取消全部常温、4选单个商品、-4取消单个商品）
        // * salesId：商品ID

        invokeApi('shoppingcart/checkCart', parms, 'post', Math.random(), function(res) {
            commit('INIT_CART', res)
            commit('FORMAT_GIFT')
        })
    },
    // 初始化凑单列表
    initCouList({ commit, state }, parms) {
        // selfMadeType：类型：1冷链/自营，2常温/非自营
        // console.log(parms)
        // console.log('凑单参数 ↑↑↑↑↑↑↑')
        return new Promise((resolve, reject) => {
            invokeApi('shoppingcart/addOnProducts', parms, 'post', Math.random(), function(res) {
                let payload = {
                    parms,
                    data: res
                }
                commit('INIT_COU_LIST', payload)
                resolve(res)
            })

        })
    },
    // 清除全部失效商品
    clearInvalid({ coommit, state }) {
        return new Promise((resolve, reject) => {
            invokeApi('shoppingcart/removeCartInvalid', {}, 'post', Math.random(), function(res) {
                commit('INIT_CART', res)
                commit('FORMAT_GIFT')
                resolve(res)
            })

        })
    },
    // 设置订单缓存
    // goOrderPay({ commit, state }) {
    //     return new Promise((resolve, reject) => {
    //         setOrderCache(0, '', 1, 1, 1, {}, '', function(res) { resolve(res) })
    //     })
    // },
    initRecommendList({ commit, state }) {
        invokeApi('shoppingcart/findRecommends', {}, 'post', Math.random(), function(res) {
            commit('INITRECOMMENDLIST',res)
            // resolve(res)
        })
    }

}

// mutations
// 改变state唯一途径
const mutations = {
    //初始化购物车全局
    INIT_CART(state, data) {
        // Object.assign(state.cart_data1, data)
        state.cart_data1 = data
    },
    //格式化赠品绑定到相应商品 , 提取失效商品, checkAll属性重新计算
    FORMAT_GIFT(state) {
        console.log('===================执行格式化赠品===========ssss')
        //默认置为true
        if(state.cart_data1.count){
            state.checkAll = true;
        }else{
            state.checkAll = false;
        }
        // 初始化相应失效商品
        state.InvalidShop = {
            //单品
            products: [],
            //套装
            groups: [],
            //促销
            promotions: [],
            isNull: true
        }
        var cart_data1 = state.cart_data1;
        let freesBox = [].concat(cart_data1.coldChainCart ? cart_data1.coldChainCart.frees : [], cart_data1.nomalTempCart ? cart_data1.nomalTempCart.frees : []);
        let idArr = {} //生成id为key   商品信息为value

        if (freesBox.length == 0) {
            // return
        } else {
            // 生成一个id数组
            freesBox.forEach((value, key) => {
                if (value.ruleType == 2) {
                    let key = value.ruleData
                    idArr[key] = value
                }
            })
        }
        console.log(idArr)
        //遍历常温和冷链
        for (const key in LISTTYPE) {
            let coldOrNomal = LISTTYPE[key];
            if (cart_data1.hasOwnProperty(coldOrNomal)) {
                // 遍历各种类型的各个商品 
                for (const index in SHOPTYPE) {
                    if (SHOPTYPE.hasOwnProperty(index)) {
                        const shop_type = SHOPTYPE[index];
                        let shopArr = cart_data1[coldOrNomal][shop_type]
                        if (shopArr && shopArr.length == 0) {
                            console.log('跳出---------------' + shop_type)
                            continue
                        }

                        for (let j in shopArr) {
                            if (shopArr.hasOwnProperty(j)) {
                                const element = shopArr[j];
                                let id = element[(SHOPID[shop_type])]
                                if (idArr[id]) {
                                    // 添加到相应商品的giftShop 属性上
                                    state.cart_data1[coldOrNomal][shop_type][j].giftShop = idArr[id]
                                }
                                console.log(state.cart_data1[coldOrNomal][shop_type][j].shoppingcartCheck)
                                // 只要有商品没被选中  则checkAll为false
                                if (state.cart_data1[coldOrNomal][shop_type][j].shoppingcartCheck == false && state.cart_data1[coldOrNomal][shop_type][j].valid) {
                                    state.checkAll = false
                                }
                                //如果为失效商品,则放入InvalidShop对象  相应数组
                                if (state.cart_data1[coldOrNomal][shop_type][j].valid == false) {
                                    (state.InvalidShop[shop_type]).push(state.cart_data1[coldOrNomal][shop_type][j])
                                    state.cart_data1[coldOrNomal][shop_type].splice(j, 1, '');
                                    state.InvalidShop.isNull = false
                                }
                            }
                        }

                    }
                }

            }
        }
        console.log(state)
        console.log('===================执行格式化===========ssss')
    },
    INIT_COU_LIST(state, payload) {
        const LISTTYPE = ['', 'coldChainCart', 'nomalTempCart'];
        state.cou_list_data[LISTTYPE[payload.parms.selfMadeType]] = payload.data
        console.log('-------------凑单列表----------')
        console.log(state.cou_list_data)
    },
    INITRECOMMENDLIST(state, data) {
        state.recommendList=data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/cart.js